<template>
	<div class="flex relative sticky top-0 z-10 justify-between items-center gap-2">
		<!--START: menu icon (mobile)-->

		<button class="block sm:hidden" type="button" @click="openSidebar">
			<menu-icon class="h-6 text-gray-500 w-6"></menu-icon>
		</button>

		<!--END: menu icon (mobile)-->
        <div>

        <div>
            <slot name="content-l"></slot>
	        <search-input></search-input>
        </div>

        </div>
		<!--START: main nav title (mobile)-->

		<div class="flex-1 text-center block sm:hidden">
			<h2 class="font-medium" v-text="mobileTitle"></h2>
		</div>

		<!--END: main nav title (mobile)-->

		<!--START: right side content-->
		<div class="flex items-center gap-2 sm:gap-4">
            <slot name="content-r"></slot>
			<div v-show="callToActions.enabled" class="hidden sm:block relative" v-on:clickout="toggleCtaMenu(false)">
				<grid class="cursor-pointer h-6 hover:text-gray-600 text-gray-500 w-6"
				      v-on:icon-click="ctaMenuToggle = !ctaMenuToggle"></grid>
				<ul v-show="ctaMenuToggle"
				    class="hidden sm:block min-w-max absolute bg-white border leading-none mt-2 right-0 rounded shadow-md text-sm">
					<li v-for="callToAction in callToActions.items" v-bind:key="callToAction.url"><a
						:href="callToAction.url" class="cursor-pointer hover:bg-gray-100 block px-4 py-2 border-b"
						v-text="callToAction.label"></a></li>
					<li v-show="callToActions.items.length === 0" class="block px-4 py-2 border-b text-gray-500">
						No menu available
					</li>
				</ul>
			</div>
            <div v-show="user" class="relative w-7 h-7" v-on:clickout="toggleNotificationMenu(false)">
	            <button type="button" @click="notificationMenuToggle = !notificationMenuToggle" class="group relative">
		            <bell class="group-hover:text-gray-600 text-gray-500 w-7 h-7"></bell>
		            <div v-show="notifications.items.length > 0" class="rounded-full bg-red-600 h-2 w-2 absolute right-1 top-1"></div>
	            </button>

                <ul v-show="notificationMenuToggle"
                    class="hidden sm:block min-w-max absolute bg-white border leading-none mt-2 right-0 rounded shadow-md text-sm">
                    <li v-for="notification in notifications.items" v-bind:key="notification.id"><a
                        :href="notification.notification_url" class="cursor-pointer hover:bg-gray-100 block px-4 py-2 border-b"
                        v-text="notification.message"></a></li>
                    <li v-show="notifications.items.length === 0" class="block px-4 py-2 border-b text-gray-500">
                        No new notification yet
                    </li>
                    <slot name="last-notification-menu"></slot>
	                <li>
		                <a class="block px-4 py-2 hover:bg-gray-100 cursor-pointer" href="/dashboard/notifications">
			                View all notifications
		                </a>
	                </li>
                </ul>
            </div>
			<a href="/login" v-if="!user">
				<button type="button" class="px-4 py-2 bg-blue-500 hover:bg-blue-600 rounded text-white">
					Login
				</button>
			</a>
			<div v-if="user" class="relative" v-on:clickout="toggleProfileMenu(false)">
				<img :src="user.avatar_url" alt="avatar"
				     class="border-gray-200 border-2 cursor-pointer h-10 hover:border-gray-300 object-cover rounded-full w-10"
				     @click="profileMenuToggle = !profileMenuToggle">
				<ul v-show="profileMenuToggle"
				    class="hidden sm:block min-w-max absolute bg-white border leading-none mt-2 right-0 rounded shadow-md text-sm">
					<li v-for="profileMenuItem in profileMenuItems" v-bind:key="profileMenuItem.url"><a
						:href="profileMenuItem.url" class="cursor-pointer hover:bg-gray-100 block px-4 py-2 border-b"
						v-text="profileMenuItem.label"></a></li>
					<slot name="last-profile-menu"></slot>
				</ul>
			</div>
		</div>

		<!--END: right side content-->

		<!--START: toggle content-->
		<!--NOTE: for mobile menu we increase click area-->

		<slot name="content-mobile-toggle"></slot>
		<ul v-if="user" v-show="profileMenuToggle"
		    class="absolute left-0 right-0 w-full bg-white border leading-none rounded shadow-md text-sm sm:hidden block"
		    style="top: 100%;">
			<li v-for="profileMenuItem in profileMenuMobileItems" v-bind:key="profileMenuItem.url" class="border-b"><a
				:href="profileMenuItem.url" class="hover:bg-gray-100 block px-4 py-5"
				v-text="profileMenuItem.label"></a></li>
			<slot name="last-profile-menu-mobile"></slot>
		</ul>
		<ul v-show="notificationMenuToggle"
		    class="absolute left-0 right-0 w-full bg-white border leading-none rounded shadow-md text-sm sm:hidden block"
		    style="top: 100%;">
			<li v-for="notification in notifications.items" :key="notification.id" class="border-b"><a
				:href="notification.notification_url" class="hover:bg-gray-100 block px-4 py-5"
				v-text="notification.message"></a></li>
			<li v-show="notifications.items.length === 0" class="border-b">
				<p class="hover:bg-gray-100 block px-4 py-5">No new notification yet</p>
			</li>
			<li><a class="hover:bg-gray-100 block px-4 py-5" :href="'/dashboard/notifications'">Show All
				Notifications</a></li>
		</ul>

		<!--END: toggle content-->

	</div>
</template>

<script>
import 'clickout-event';

import axios from "@js/components/axios";

import Bell from "@js/icons/Bell.vue";
import Grid from "@js/icons/Grid.vue";
import MenuIcon from "@js/icons/Menu.vue";
import SearchInput from "@js/components/forms/Search.vue";
import SearchIcon from "@js/icons/Search.vue";
import ButtonVue from "@js/components/Button.vue";
import FormText from "@js/components/forms/Text.vue";

export default {
	name: "MainNav",
	props: {
		mobileTitle: {
			default: 'docs',
		},
	},
	components: {
        FormText,
		Bell,
		Grid,
		MenuIcon,
		SearchInput,
		SearchIcon,
        ButtonVue,
	},
	data() {
		return {
			profileMenuToggle: false,
			notificationMenuToggle: false,
			ctaMenuToggle: false,
			notifications: {
				items: [],
				enabled: true
			},
			callToActions: {
				items: [],
				enabled: true,
			},
			profileMenuItems: [],
			profileMenuMobileItems: [],
			user: user,
		}
	},
    computed: {
        isLogin() {
            return !_.isEmpty(this.user)
        },
        showCallToActionsIcon() {
            return !_.isEmpty(this.callToActions)
        }
    },
	methods: {
		toggleProfileMenu(toggle) {
			this.profileMenuToggle = toggle
		},
		toggleNotificationMenu(toggle) {
			this.notificationMenuToggle = toggle
		},
		toggleCtaMenu(toggle) {
			this.ctaMenuToggle = toggle
		},
		openSidebar() {
			let self = this
			self.profileMenuToggle = false
			self.$nextTick(() => {
				self.$emit('open-sidebar')
			})
		},
		loadNotifications() {
			let self = this
			self.notifications.enabled = self.notificationsOptions.enabled
			self.notifications.items = self.notificationsOptions.items
			if (self.notificationsOptions.shouldFetchRemote) {
				axios().get(self.notificationsOptions.remoteUrl)
					.then(response => self.notifications.items = response.data)
			}
		},
		loadCta() {
			let self = this
			self.callToActions.enabled = self.callToActionsOptions.enabled
			self.callToActions.items = self.callToActionsOptions.items
			if (self.callToActionsOptions.shouldFetchRemote) {
				axios().get(self.callToActionsOptions.remoteUrl)
					.then(response => self.callToActions.items = response.data)
			}
		},
	},
	mounted() {

        this.callToActions.items.push(
            {
                url:'/inquiry',
                label: 'Submit Inquiries',
            }
        )

        this.profileMenuItems.push(
	        {
		        url: '/dashboard',
		        label: 'Dashboard'
	        },
            {
                url: '/dashboard/profile',
                label: 'Profile'
            },
            {
                url: '/logout',
                label: 'Log out'
            })

		this.profileMenuMobileItems.push(
			{
				url: '/new-inquiry',
				label: 'Submit Inquiry'
			},
			{
				url: '/dashboard',
				label: 'Dashboard'
			},
			{
				url: '/dashboard/profile',
				label: 'Profile'
			},
			{
				url: '/dashboard/notification',
				label: 'Notification'
			},
			{
				url: '/logout',
				label: 'Log out'
			})

		this.notifications.items = notifications

    }

}
</script>
